// Add your custom JS here.
jQuery(function ($) {
  $("#direct-go-to").on("submit", function (evt) {
    evt.preventDefault();

    $("#direct-go-to .direct-go-to-error").html("");
    let data = {
      action: "resortia-go-to",
      property: $(this).find("input").val(),
    };
    $.post(streamlinecoreConfig.ajaxUrl, data, function (response) {
      window.location = response.data.url;
    }).fail(function () {
      $("#direct-go-to .direct-go-to-error").html("Property Not Found");
    });
  });
});
